import { ClienteSesion } from './../../model/cliente-sesion';
import { Component } from '@angular/core';
import { VotacionService } from 'src/app/cliente/votacion.service';
import { AlertaService } from 'src/app/util/alerta.service';
import { Router} from '@angular/router';
import { ParametrosConst } from 'src/app/util/parametrosConst';
import { IntranetService } from 'src/app/intranet/intranet.service';
import { Parametro } from 'src/app/intranet/model/parametro';
import { MatSnackBar } from '@angular/material/snack-bar';


interface Votante {
  dni: string;
  nombre: string;
  tipo: 'propio' | 'delegado';
  yaVoto: boolean;
  idFoto: number;
  puedeVotar: boolean;
  tipoAsistente: string;
}

@Component({
  selector: 'sura-bienvenida-asistente',
  templateUrl: './bienvenida-asistente.component.html',
  styleUrls: ['./bienvenida-asistente.component.scss']
})
export class BienvenidaAsistenteComponent {

  deshabilitarBtn = false;
  dataStore: ClienteSesion;
  datosAsamblea: any = {
    descripcionAsamblea: '',
    fechaInicio: '',
    horaInicio: ''
  };
  listTipoDisclaimer: Parametro[] = [];
  edicionVoto= false;
  disclaimerVoto = false;
  mostroDisclaimer = false;

  // Nuevas variables para selección de votantes
  mostrarSeleccionVotantes: boolean = false;
  esRepresentante: boolean = false;
  votantesPropios: Votante[] = [];
  votantesDelegados: Votante[] = [];
  votanteSeleccionado: Votante | null = null;
  votanteUnico: Votante | null = null;

  constructor(
    private _votacionService: VotacionService,
    private alertaService: AlertaService,
    private router: Router,
    private intranetService: IntranetService,
  private snackBar: MatSnackBar ) {
    this.dataStore = this._votacionService.loadSessionData();

    this.edicionVoto = localStorage.getItem(ParametrosConst.EDICION_VOTO) == 'S' ? true : false;
    this.obtenerDatosAsamblea();
  }

  containsCodigoAsamblea(listTipoDisclaimer, idAsamblea): boolean {
    return listTipoDisclaimer.some(param => param.codigo === idAsamblea);
  }

  ingresarAsamblea() {
   
            if (this._votacionService.isAuthenticated() && this.dataStore && this.dataStore.asistente) {
              console.log(this.listTipoDisclaimer);
              if(this.containsCodigoAsamblea(this.listTipoDisclaimer, this.dataStore.asistente.idAsamblea) && !this.mostroDisclaimer){
                this.disclaimerVoto = true;
                this.mostroDisclaimer = true;
              }else{   
                 if (this.esRepresentante) {
                    this.mostrarSeleccionVotantes = true;
                  } else {             
                      this.deshabilitarBtn = true;
                      this._votacionService.obtenerPreguntaActiva(this.dataStore.asistente.idAsamblea,
                            this.dataStore.asistente.id, this.dataStore.asistente.idFoto, this.datosAsamblea.tipoAsistencia, 'P').then(r => {
                            if (r instanceof Array && r.length === 0) {
                              this.alertaService.info('No cuentas con preguntas por responder.');
                              this._votacionService.logout();
                              this.router.navigate(['/validacion'], {queryParams: {}});
                            } else {
                              if (this.datosAsamblea.tipoAsistencia === 'M' || this.datosAsamblea.tipoAsistencia === 'H') {
                                this.obtenerPreguntas('/votacion');
                              } else {
                                this.obtenerPreguntas('/votacionRemota');
                              }
                            }
                            this.deshabilitarBtn = false;
                          }).catch(err => {
                            if(err == 'Participe o representante ya voto'){
                              this.obtenerPreguntas('/votacionEdicion');
                            }else{
                              this.alertaService.info(err);
                              this.deshabilitarBtn = false;
                            }
                      });
                    }
                }      
              } else {
                this._votacionService.logout();
                this.router.navigate(['/validacion']);
              }
        
  }

  obtenerPreguntas(url: string) {
    this.router.navigate([url]);
  }

  obtenerDatosAsamblea() {
    if (this._votacionService.isAuthenticated() && this.dataStore && this.dataStore.asistente) {
      this._votacionService.obtenerDatosAsamblea(this.dataStore.asistente.idAsamblea, this.dataStore.token).then(r => {
        this.datosAsamblea = r;
        this._votacionService.obtenerPreguntaActiva(this.dataStore.asistente.idAsamblea,
          this.dataStore.asistente.id, this.dataStore.asistente.idFoto, this.datosAsamblea.tipoAsistencia,this.edicionVoto ? 'E':'P').then(r => {
          if (r instanceof Array && r.length === 0) {

            if(this.esRepresentante){
              //const completado = this.verificarVotacionCompleta();
            }else{
                this.alertaService.info('No cuentas con preguntas por responder.');
                this._votacionService.logout();
                this.router.navigate(['/validacion'], {queryParams: {}});
            }
          }  
          console.log(r)
          if(r[0].estado !== "I" && (this.datosAsamblea.tipoAsistencia === 'R' || this.datosAsamblea.tipoAsistencia === 'H')){
            
            this._votacionService.obtenerParametroAcceso(ParametrosConst.TIPO_DISCLAIMER_ASAMBLEA).then(resultado => {
              if (resultado instanceof Array) {
                this.listTipoDisclaimer = resultado;
              }
            }).catch(error => {
              //this.alertaService.error(error);
            });
          }

        }).catch(err => {
          if(err == 'No se puede votar anticipadamente' || err == 'Asamblea no iniciada o no  tiene preguntas activas'){
            this.alertaService.info(err);
            this._votacionService.logout();
            this.router.navigate(['/validacion'], {queryParams: {}});
            this.deshabilitarBtn = false;
          }
    });     
      }).catch(err => {
        console.error(err);
        this.alertaService.error(err);
        this._votacionService.logout();
        this.router.navigate(['/validacion']);
      });
    }
  }



  ngOnInit(): void {
    this.verificarRepresentacion();

    const estadoGuardado = sessionStorage.getItem('estadoBienvenida');
    if (estadoGuardado) {
      const estado = JSON.parse(estadoGuardado);
      this.votantesPropios = estado.votantesPropios;
      this.votantesDelegados = estado.votantesDelegados;
      this.votanteSeleccionado = estado.votanteSeleccionado;
      this.esRepresentante = estado.esRepresentante;
      
      // Limpiar el estado guardado
    }

    if(sessionStorage.getItem('votanteactivo') == 'S'){
      this.mostrarSeleccionVotantes = true;
    }
  
  }


  verificarRepresentacion(): void {
    // Llamar al servicio para verificar si es representante
    // Esto debería venir de tu backend
    const datosUsuario = JSON.parse(localStorage.getItem('usuario') || '{}');
    const idAsamblea = localStorage.getItem('idAsamblea');
  
     this.votantesDelegados = this.dataStore.asistente.miembros.map(familiar => ({
      dni: familiar.numeroDocumento,
      nombre: familiar.nombres ,
      tipo: 'delegado' as const,
      idFoto: familiar.idFoto,
      yaVoto: false,
      puedeVotar: true,
      tipoAsistente: familiar.tipoAsistente
    }));

    this.votantesPropios = [{
      dni: this.dataStore.asistente.numeroDocumento,
      nombre: this.dataStore.asistente.nombres + ' ' + this.dataStore.asistente.apellidos,
      tipo: 'propio',
      idFoto: this.dataStore.asistente.idFoto,
      yaVoto: false,
      puedeVotar: true,
      tipoAsistente: this.dataStore.asistente.tipoAsistente
    }];

    // Verificar si el votante propio coincide con el último delegado
    if (this.votantesDelegados.length > 0) {
      const ultimoDelegado = this.votantesDelegados[this.votantesDelegados.length - 1];
      const votaltePropio = this.votantesPropios[0];
      
      if (votaltePropio && ultimoDelegado.dni === votaltePropio.dni) {
        if(ultimoDelegado.tipoAsistente === 'R'){
          votaltePropio.puedeVotar = false;
        }
        this.votantesPropios[0] = votaltePropio;
        this.votantesDelegados.pop(); // Eliminar el último delegado si se repiten
      }
     
    } 

    this.esRepresentante = this.votantesDelegados.length > 0;
    
  }

  // Cargar lista de votantes representados
  cargarVotantesRepresentados(): void {
    /* Datos de ejemplo - reemplazar con llamada real al servicio
    this.votantesPropios = [
      {
        dni: '07767874',
        nombre: 'AUGUSTO URMENETA PERYRA',
        tipo: 'propio',
        yaVoto: false,
        puedeVotar: true
      }
    ];

    this.votantesDelegados = [
      {
        dni: '06449201',
        nombre: 'WILLEM SCHOL CALLE',
        tipo: 'delegado',
        yaVoto: false,
        puedeVotar: true
      },
      {
        dni: '48838682',
        nombre: 'VICTOR EDUARDO',
        tipo: 'delegado',
        yaVoto: true, // Este ya votó
        puedeVotar: true
      }
    ];
    */
    // Seleccionar el primero por defecto
    if (this.votantesPropios.length > 0) {
      this.votanteSeleccionado = this.votantesPropios[0];
    }
  }

  // Método para mostrar la selección de votantes
  mostrarSeleccion(): void {
    if (this.esRepresentante) {
      this.mostrarSeleccionVotantes = true;
    } else {
      // Si no es representante, ir directamente a votación
      this.ingresarAsamblea();
    }
  }

  // Método existente (modificado)
  

  // Nuevos métodos para selección de votantes
  seleccionarVotante(votante: Votante): void {
    if (votante.yaVoto) {
      this.snackBar.open(`${votante.nombre} ya ha votado`, 'Cerrar', {
        duration: 3000
      });
      return;
    }
    
    this.votanteSeleccionado = votante;
  }

  irAVotacion(): void {
    if (!this.votanteSeleccionado || this.votanteSeleccionado.yaVoto) {
      return;
    }
    
    // Buscar y actualizar el flag yaVoto del votante seleccionado
    const votanteEnDelegados = this.votantesDelegados.find(v => v.dni === this.votanteSeleccionado?.dni);
    const votanteEnPropios = this.votantesPropios.find(v => v.dni === this.votanteSeleccionado?.dni);

    if (votanteEnDelegados) {
      votanteEnDelegados.yaVoto = true;
    }
    if (votanteEnPropios) {
      votanteEnPropios.yaVoto = true;
    }

    /**
     * 
     *  dni: familiar.numeroDocumento,
      nombre: familiar.nombres ,
      tipo: 'delegado' as const,
      idFoto: familiar.idFoto,
      yaVoto: false,
      puedeVotar: true
     * 
     */

      const estadoActual = {
        votantesPropios: this.votantesPropios,
        votantesDelegados: this.votantesDelegados,
        votanteSeleccionado: this.votanteSeleccionado,
        esRepresentante: this.esRepresentante
      };

  // Guardar en sessionStorage para persistir durante la sesión
  sessionStorage.setItem('estadoBienvenida', JSON.stringify(estadoActual));

    // Guardar votante seleccionado
    localStorage.setItem('votanteActual', JSON.stringify({
      dni: this.votanteSeleccionado.dni,
      nombres: this.votanteSeleccionado.nombre,
      tipo: this.votanteSeleccionado,
      idFoto: this.votanteSeleccionado.idFoto,
      idAsamblea : this.dataStore.asistente.idAsamblea
    }));

    console.log(this.votanteSeleccionado);
    



    sessionStorage.setItem('votanteactivo', 'S');
    // Navegar a votación
    //this.router.navigate(['/votacion']);
    if(this.edicionVoto){
      this.router.navigate(['/votacionEdicion'], { replaceUrl: false });
    }else{
     this.router.navigate(['/votacion'], { replaceUrl: false });
    }
  }

  regresar(): void {
     this._votacionService.logout();
        this.router.navigate(['/validacion']);
  }

}
